module.exports = "<div class=\"basicline\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/basicline.html
// module id = 625
// module chunks = 0